//hardcode height and width of the ultrasound image
export const IMAGE_WIDTH = 630;
export const IMAGE_HEIGHT = 405;
export const SCALE = 0.01;
export const SCALE_FACTOR = 1.0 / 0.3059332669;
export const SEGMENTATION_CLASS_ACRONYM = {
  Aorta: 'AO',
  'Aortic Valve': 'AV',
  'Left Atrium': 'LA',
  'Left Ventricle': 'LV',
  'Right Atrium': 'RA',
  'Right Ventricle': 'RV',
  'Left Superior Pulmonary Vein': 'LSPV',
  'Right Superior Pulmonary Vein': 'RSPV',
  'Left Inferior Pulmonary Vein': 'LIPV',
  'Right Inferior Pulmonary Vein': 'RIPV',
  'Right Middle Pulmonary Vein': 'RMPV',
  'Left Common Pulmonary Vein': 'LCPV',
  'Left Pulmonary Veins': 'LPV',
  'Right Pulmonary Veins': 'RPV',
  'Mitral Valve': 'MV',
  'LVOT Area': 'LVOT',
  'Left Ventricular Outflow Tract': 'LVOT',
  'Right Ventricular Outflow Tract': 'RVOT',
  'Anterolateral Papillary Muscle': 'ALPM',
  'Posteromedial Papillary Muscle': 'PMPM',
  'Papillary Muscles': 'PM',
  'Left Atrial Appendage': 'LAA',
  'Coronary Sinus': 'CS',
  'Tricuspid Valve': 'TV',
  'Pulmonary Artery': 'PA',
  'Right Coronary Cusp': 'RCC',
  'Left Coronary Cusp': 'LCC',
  'Non-Coronary Cusp': 'NCC',
  'Fossa Ovalis': 'FO',
  'Interatrial Septum': 'IAS',
  'Interventricular Septum': 'IVS',
  'Superior Vena Cava': 'SVC',
  'Inferior Vena Cava': 'IVC',
  'Eustachian Ridge': 'ER',
  'Moderator Band': 'MB',
  Esophagus: 'ES',
  'Left Circumflex Coronary Artery': 'LCX',
  Other: 'OTHER',
};
